import { ArrowForwardIos } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useLayoutEffect, useRef, useState } from 'react';
import { ContentWithLineBreaks } from '../ContentWithLineBreaks/index.tsx';
import {
  AvatarContainer,
  ButtonContainer,
  ContentContainer,
  ContentInnerContainer,
  Image,
  ImageContainer,
  ReviewContainer,
  SecondaryText,
} from './styled.ts';
import { type ReviewProps } from './types.ts';

export const Review = ({
  author,
  avatarPath,
  content,
  createdAt,
  id,
  preview = false,
  setActiveReviewDrawer,
}: ReviewProps) => {
  const [showReadMore, setShowReadMore] = useState<boolean>(false);
  const ref = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    if (preview && ref.current) {
      const isTextClamped = ref.current.scrollHeight > ref.current.clientHeight;

      if (isTextClamped) {
        setShowReadMore(true);
      }
    }
  }, [content, preview]);

  return (
    <ReviewContainer>
      <AvatarContainer>
        {avatarPath ? (
          <ImageContainer>
            <picture>
              <Image alt={author} loading="lazy" src={avatarPath} />
            </picture>
          </ImageContainer>
        ) : undefined}
      </AvatarContainer>
      <ContentContainer preview={preview}>
        <Typography
          sx={{ color: theme => theme.mainTextPrimary, marginBottom: theme => theme.spacing(1) }}
          variant="body2"
        >
          <SecondaryText>By</SecondaryText> <strong>{author}</strong>
          <SecondaryText> on {format(new Date(createdAt), 'MMMM d, yyyy')}</SecondaryText>
        </Typography>
        <ContentInnerContainer
          ref={ref}
          sx={{
            ...(preview
              ? {
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 5,
                  display: '-webkit-box',
                  overflow: 'hidden',
                }
              : {}),
          }}
        >
          <ContentWithLineBreaks sx={{ color: theme => theme.mainTextPrimary }}>{content}</ContentWithLineBreaks>
        </ContentInnerContainer>
        {showReadMore ? (
          <ButtonContainer>
            <Button
              onClick={() => {
                if (setActiveReviewDrawer) {
                  setActiveReviewDrawer({ id });
                }
              }}
            >
              Read more <ArrowForwardIos />
            </Button>
          </ButtonContainer>
        ) : undefined}
      </ContentContainer>
    </ReviewContainer>
  );
};
